import Regularisation from "./regularisation";
export default Regularisation;